import { Badge } from "./ui";
import { useT } from "@/i18n";
import type { CustomerRequestStatus } from "@/lib/api";

export function RequestStatusBadge({ status }: { status: CustomerRequestStatus }) {
  const { t } = useT();
  const mapping: Record<CustomerRequestStatus, { tone: Parameters<typeof Badge>[0]["tone"]; label: string }> = {
    pending: { tone: "brand", label: t("status.pending") },
    verified: { tone: "brand", label: t("status.verified") },
    issued: { tone: "green", label: t("status.issued") },
    rejected: { tone: "red", label: t("status.rejected") },
    revoked: { tone: "slate", label: t("status.revoked") },
    expired: { tone: "neutral", label: t("status.expired") },
  };
  const item = mapping[status];
  return (
    <Badge tone={item.tone} dot>
      {item.label}
    </Badge>
  );
}
